
export class NotificationEvent {
  public eventID: number;
  public eventName: string;
  public isActive: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/events/notification-event.model.ts